import * as React from "react";
import { chakra, type HTMLChakraProps } from "@chakra-ui/react";

export const OrangeLines = (props: HTMLChakraProps<"svg">) => (
  <chakra.svg
    width="1536"
    height="438"
    viewBox="0 0 1536 438"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line x1="-161" y1="329.5" x2="555" y2="329.5" stroke="#D5AA60" />
    <line x1="121.134" y1="898.647" x2="555.589" y2="329.52" stroke="#D5AA60" />
    <line
      y1="-0.5"
      x2="716"
      y2="-0.5"
      transform="matrix(-0.606781 -0.794869 -0.794869 0.606781 555.455 330.126)"
      stroke="#D5AA60"
    />
    <line x1="1177" y1="329" x2="1553.5" y2="329" stroke="#F3D9B5" />
    <line
      x1="743.134"
      y1="898.647"
      x2="1177.59"
      y2="329.521"
      stroke="#F3D9B5"
    />
    <line
      y1="-0.5"
      x2="716"
      y2="-0.5"
      transform="matrix(-0.606781 -0.794869 -0.794869 0.606781 1177.45 330.126)"
      stroke="#F3D9B5"
    />
    <defs>
      <clipPath id="clip0_2_85"></clipPath>
    </defs>
  </chakra.svg>
);
